module.exports = __webpack_public_path__ + "img/cursore.faef9735.svg";